var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85193 12.1485H4.69638L10.489 6.35588L9.64453 5.51144L3.85193 11.304V12.1485ZM3.25934 13.3337C3.09144 13.3337 2.9507 13.2769 2.83712 13.1633C2.72354 13.0497 2.66675 12.909 2.66675 12.7411V11.304C2.66675 11.146 2.69638 10.9954 2.75564 10.8522C2.8149 10.709 2.89885 10.583 3.00749 10.4744L10.489 3.00773C10.6075 2.89909 10.7384 2.81514 10.8816 2.75588C11.0248 2.69662 11.1754 2.66699 11.3334 2.66699C11.4914 2.66699 11.6445 2.69662 11.7927 2.75588C11.9408 2.81514 12.0692 2.90403 12.1779 3.02255L12.9927 3.85218C13.1112 3.96082 13.1976 4.08921 13.2519 4.23736C13.3063 4.38551 13.3334 4.53366 13.3334 4.68181C13.3334 4.83983 13.3063 4.99045 13.2519 5.13366C13.1976 5.27687 13.1112 5.40773 12.9927 5.52625L5.52601 12.9929C5.41737 13.1016 5.29144 13.1855 5.14823 13.2448C5.00502 13.304 4.8544 13.3337 4.69638 13.3337H3.25934ZM10.0593 5.94107L9.64453 5.51144L10.489 6.35588L10.0593 5.94107Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGrey);
export default __webpack_public_path__ + "static/media/edit_grey.135eb9d5474012a6dea262f1d489180f.svg";
export { ForwardRef as ReactComponent };